<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="description" slot-scope="{ item }">
            {{item.description | elipsis(80)}}
        </template>

        <template slot="created_at" slot-scope="{ item }">
            {{item.created_at | datetime}}
        </template>

        <template slot="files" slot-scope="{ item }">
            <div v-if="item.files.length" v-for="(file, i) in item.files">
                <a :href="'/download/' + file.id" target="_blank">{{i+1}} - {{ file.name }}</a>
            </div>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" title="Ver Comentarios" :disabled="!item.comments.length" @click="seeCommentsByPetition(item)"><i class="fa fa-comments"></i></b-button>
            <b-button variant="primary" size="sm" title="Ver PQR" @click="seeMore(item)"><i class="fa fa-search-plus" aria-hidden="true"></i></b-button> 
            <b-button variant="primary" size="sm" title="Asignar Responsable" @click="startAssignUserToPetition(item)"><i class="fa fa-user-plus" aria-hidden="true"></i></b-button>
            <b-button variant="primary" size="sm" title="Agregar Comentario" @click="startAddComment(item)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></b-button>
            <app-btn-confirm
                v-if="
                    item.petition_status &&
                    item.petition_status.slug === 'recibida'
                "
                variant="danger"
                confirm-variant="danger"
                title="Eliminar PQR"
                @confirm="deletePetition(item)"
            >
                <i class="fa fa-trash" aria-hidden="true"></i>
            </app-btn-confirm>
        </template>
    </app-data-table>
</template>
<script>
    export default {
        data() {
            return {
                fields: [
                    {
                        key: 'id',
                        label: 'ID'
                    },
                    {
                        key: 'petition_type.name',
                        label: 'Tipo'
                    },
                    {
                        key: 'client.name',
                        label: 'Cliente'
                    },
                    {
                        key: 'user.name',
                        label: 'Usuario creador'
                    },
                    {
                        key: 'description',
                        label: 'Descripción'
                    },
                    {
                        key: 'created_at',
                        label: 'Fecha creación'
                    },
                    {
                        key: 'files',
                        label: 'Archivos',
                        sortable: false
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ]
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            seeCommentsByPetition: {
                type: Function,
                required: true
            },
            seeMore: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            },
            startAssignUserToPetition: {
                type: Function,
                required: true
            },
            startAddComment: {
                type: Function,
                required: true
            },
            deletePetition: {
                type: Function,
                required: true
            }
        },
        methods: {
            onSort(ctx) {
                this.$emit('sort', ctx);
            }
        }
    }
</script>